import React from 'react'
import InputFill from '../form/InputFill'
import HeadingForm from '../elements/HeadingForm'
import Button from '../elements/Button'
import ModalForm from '../common/modal-form'

import { useTranslation } from 'react-i18next'

const UpdatePasswordModal = ({
    handleSubmit,
    form,
    handleInputChange,
    clearErrorField,
    errors,
    isOpen,
    setIsOpen,
}) => {
    const { t } = useTranslation()

    const fields = [
        {
            label: t('customerInfo.password'),
            name: 'userPassword',
            props: {
                type: 'password',
            },
        },
        {
            label: t('customerInfo.newPassword'),
            name: 'userNewPassword',
            props: {
                type: 'password',
            },
        },
        {
            label: t('customerInfo.confirmNewPassword'),
            name: 'confirmNewPassword',
            props: {
                type: 'password',
            },
        },
    ]

    return (
        <ModalForm centered isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <form className="py-4" onSubmit={handleSubmit}>
                <HeadingForm>{t('updatePassword.title')}</HeadingForm>

                {fields.map((field, index) => {
                    const Component = field.component || InputFill
                    return (
                        <div key={index}>
                            <Component
                                className="mt-6"
                                label={t(field.label)}
                                name={field.name}
                                value={form[field.name]}
                                error={errors[field.name]}
                                onChange={handleInputChange}
                                onFocus={() => clearErrorField(field.name)}
                                {...field.props}
                            />
                        </div>
                    )
                })}

                <div className="mt-6">
                    <Button fullWidth>{t('button.agree')}</Button>
                </div>
            </form>
        </ModalForm>
    )
}

export default UpdatePasswordModal
